var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.021,
    y: 8.07227,
    width: 30.872,
    height: 35.5028,
    fill: "#0F5671"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7259 0.353841C20.2067 0.353841 13.5048 3.37809 8.60006 8.28202C3.69612 13.186 0.671875 19.8878 0.671875 27.3259C0.671875 34.8451 3.69612 41.547 8.60006 46.4517C13.504 51.3564 20.2058 54.3799 27.7259 54.3799C35.1634 54.3799 41.866 51.3556 46.7697 46.4517C51.6737 41.5478 54.6979 34.846 54.6979 27.3259C54.6979 19.8883 51.6737 13.1858 46.7697 8.28202C41.8658 3.37809 35.164 0.353841 27.7259 0.353841ZM16.8553 27.3259L30.1773 14.0849L33.6918 17.5176L23.8023 27.3251L33.6918 37.2146L30.1773 40.6473L16.8553 27.3259Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackBtn);
export default __webpack_public_path__ + "static/media/back-btn.59b24d0a54fe5afe39083f7ea4309fbb.svg";
export { ForwardRef as ReactComponent };